
import React from 'react';
import CrisisManagement from 'views/CrisisManagement';

const CustomersPage = () => {
  return <CrisisManagement />;
};

export default CustomersPage;
